import { useCallback, useEffect, useState } from 'react'
import { RiDeleteBin2Line, RiUploadCloud2Line } from 'react-icons/ri'
import { ErrorMessage, Form, Formik } from 'formik'
import usePost from '@/Utils/Hooks/usePost'
import { AdminFAQsAPI, AdvertisementListAPI, BaseURL, CommonUploadAPI, GroupContactsAPI, UploadContactsAPI } from '@/Utils/APIRequest/Endpoints'
import { CustomToast } from '@/Utils/CustomToast'
import Modal from '@/Component/Common/Modal'
import { RequiredField, YupObject } from '@/Utils/ValidationSchema'
import FormikInput from '@/Component/Common/Forms/FormikInput'
import Cookies from 'js-cookie';
import ErrorMessages from '@/Utils/ErrorMessages'
import { LoaderSVG } from '@/Component/Common/SVGs/CommonSVG'
import GradientButton from '@/Component/Common/Forms/GradientButton'
import BorderButton from '@/Component/Common/Forms/BorderButton'
import FormikSelect from '@/Component/Common/Forms/FormikSelect'
import ValidationMsg from '@/Utils/ValidationSchema/ValidationMsg'
import FormLabel from '@/Component/Common/Forms/FormLabel'
import axios from 'axios'
import { CiCircleRemove } from 'react-icons/ci'
import Dropzone from 'react-dropzone'

const AddGroupModal = (props) => {
    const { modal, setModal, refetch, isFromContacts = false } = props;
    const accessToken = Cookies.get('aat') || Cookies.get("verifyUAT")
    const [excelFile, setExcelFile] = useState<any>(null)
    const [progress, setProgress] = useState(0)

    const { isPending, mutate } = usePost(modal?.id ? `${GroupContactsAPI}` : UploadContactsAPI, null, (response) => {
        if (response.status == 201 || response.status == 200) {
            CustomToast("success", modal?.groupId ? 'Contacts uploaded successfully' : modal?.id ? 'Group updated successfully' : 'Group added successfully')
            refetch();
            setModal(null);
        }
    }, modal?.id ? 'put' : null);

    const onFileChange = async (event: any, type = "") => {
        if (event) {
            let formData: any = new FormData()
            const files = event
            formData.append('file', files)
            formData.append('type', 'user-excel')
            formData.append('root', "files")

            const config = {
                headers: { authorization: `bearer ${accessToken}` },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setProgress(percentCompleted);
                }
            }
            try {
                let response = await axios.post(`${BaseURL}${CommonUploadAPI}`, formData, config)

                if (response?.status === 200 || response?.status === 201) {
                    setExcelFile(response?.data)
                }
                setProgress(0)
            } catch (error: any) {
                CustomToast("error", error?.response?.data?.message)
                setProgress(0)
            }
        }
    }
    const bytesToMB = (bytes) => {
        return (bytes / (1024 * 1024)).toFixed(2);
    }
    const removeSelectedFile = () => {
        setExcelFile(null)
        setProgress(0)
    }

    const onDropExcel = useCallback((acceptedFiles, fileRejections) => {
        let Obj: any = {
            "too-many-files": `You can select only one zip file`,
            "file-invalid-type": "Please provide valid file type"
        }

        acceptedFiles.forEach((file) => {
            onFileChange(file, "song-excel")
        })

        if (fileRejections?.length > 0) {
            if (fileRejections?.length > 0) {
                CustomToast("error", Obj[fileRejections?.[0]?.errors?.[0].code] ?? "Something went wrong")
            }
        }

    }, [])

    return (
        <Modal modalSize="md:w-2/4 xl:w-1/3 2xl:w-1/4" modal={modal} setModal={setModal} childMainClass="max-h-[90vh] overflow-y-auto">
            {isFromContacts ? <h3 className='text-2xl font-semibold mb-3'>Upload Contacts</h3> :
                <h3 className='text-2xl font-semibold mb-3'>{`${modal?.id ? 'Edit' : 'Add'} Group`} </h3>}
            <Formik
                enableReinitialize
                initialValues={{
                    name: modal?.name ?? '',
                }}
                validationSchema={YupObject({
                    name: isFromContacts ? '' : RequiredField('Group name is required'),
                })}
                onSubmit={(values: any) => {
                    if (!excelFile?.fileName && !modal?.id) {
                        CustomToast("error", "Please upload CSV file")
                        return
                    }
                    const preparedValues: any = { ...values }
                    let groupId = modal?.id || modal?.groupId
                    const formattedValues = {
                        ...preparedValues,
                        groupId: groupId ?? null,
                        fileName: excelFile?.fileName,
                    };

                    mutate(formattedValues)
                }}
            >
                {({ errors, touched }) => (
                    <Form>
                        {!modal?.groupId && <div className='mb-4 relative'>
                            <FormLabel title="Group Name" />
                            <FormikInput inputProps={{ type: "text", name: "name", placeholder: "Enter group name" }} />
                            <ErrorMessages fieldName="name" errors={errors} touched={touched} />
                        </div>}
                        {!modal?.id &&
                            <div className='relative'>
                                <FormLabel title="Upload Contacts CSV" />
                                {excelFile?.fileName ?
                                    <div className='!bg-tertiary/30 border border-dashed border-tertiary py-3 md:mr-2 mb-2 shadow-none'>
                                        <div className='flex items-center justify-between p-2'>
                                            <div className='flex flex-col'>
                                                <span className='text-sm font-semibold mb-1'>{excelFile?.fileName}</span>
                                                <span className='text-xs text-gray-20 '>{bytesToMB(excelFile?.size ?? 0)} MB</span>
                                            </div>
                                            <span onClick={removeSelectedFile} className='cursor-pointer'>
                                                <CiCircleRemove className='text-black h-6 w-6 font-bold' />
                                            </span>
                                        </div>
                                    </div>
                                    : <div className="flex items-center flex-col"><label htmlFor='excel' className='cursor-pointer w-full text-center'>
                                        {progress > 0 ?
                                            <div className='p-5 mb-3 border border-tertiary border-dashed w-full rounded-lg'>
                                                <p className="flex items-end justify-center gap-x-1">
                                                    Uploading
                                                    <div className='h-1 w-1 bg-black rounded-full animate-bounce [animation-delay:-0.6s]'></div>
                                                    <div className='h-1 w-1 bg-black rounded-full animate-bounce [animation-delay:-0.3s]'></div>
                                                    <div className='h-1 w-1 bg-black rounded-full animate-bounce'></div>
                                                    <p>{progress}%</p>
                                                </p>
                                            </div> :
                                            <>
                                                <Dropzone onDrop={onDropExcel} maxFiles={1} accept={{
                                                    'text/csv': ['text/csv']
                                                }}>
                                                    {({ getRootProps, getInputProps }) => {
                                                        return (
                                                            <div {...getRootProps({ className: 'p-5 border border-tertiary border-dashed w-full rounded-lg' })}>
                                                                <input {...getInputProps()} />
                                                                <p>Drag & drop CSV file here, <br />or click to select files</p>
                                                            </div>
                                                        );
                                                    }}
                                                </Dropzone>
                                            </>
                                        }
                                    </label>
                                        <a href="https://d1i31jsql1ktvl.cloudfront.net/files/user-excel/contacts-upload-example122_478135739.csv" download="contacts-upload-example.csv" rel="noopener noreferrer" className="text-secondary underline text-sm mt-2">Download Sample File</a>
                                    </div>}
                            </div>
                        }
                        <div className="flex items-center justify-center gap-3.5 mt-5">
                            <GradientButton buttonType="submit" customClass="flex items-center gap-2" disable={isPending}>
                                Submit
                                {isPending && <LoaderSVG />}
                            </GradientButton>
                            <BorderButton buttonType="button" title="Cancel" onClick={() => setModal(null)} />
                        </div>
                    </Form>
                )
                }
            </Formik >
        </Modal >
    )
}

export default AddGroupModal
